// extracted by mini-css-extract-plugin
export default {"notFoundContainer":"NotFound_notFoundContainer__Iwlal","image":"NotFound_image__m+DC3"};